jQuery(document).ready(function($) {
    
   $('.product-item').addClass('show');
  
  // $('toggle-tab.list-view').each(function(){
  //   $(this).click(function(){
  //     $(this).toggleClass('opened');
  //   });
  // });

  // $(window).on('beforeunload', function() {
      
  // });

// var timeRemaining = 5 * 60 * 60 * 1000;

// function clearCart() {
//   fetch('/cart/clear.js', {
//     method: 'POST'
//   });
// }


// var intervalId = setInterval(function() {
//   timeRemaining -= 1000;  

//   if (timeRemaining <= 0) {
//     clearInterval(intervalId); 
//     clearCart(); 
//   }
// }, 1000);
  // Set a timer to clear the cart after 1 hour
setTimeout(clearCart, 86400000);

// Function to clear the cart
function clearCart() {
    // Your API call to clear the cart using the Shopify Cart API
    fetch('/cart/clear', { method: 'POST' })
        .then(response => {
            if (response.ok) {
                console.log('Cart cleared successfully!');
                // Optionally, redirect the user to the home page or another page
            } else {
                console.error('Failed to clear cart:', response.status);
            }
        })
        .catch(error => {
            console.error('Error clearing cart:', error);
        });
}

  // $('button.add-to-cart').click(function(){
  //   Cookies.set('cartTimer', 'start');
  //    setTimeout(function() {
  //       Cookies.remove('cartTimer');
  //       Cookies.set('cartTimer', 'end');
      
  //     }, 24000);
  // });

  // if(Cookies.get('cartTimer') == 'end'){
  //     $.ajax({
  //           type: 'POST',
  //           url: '/cart/clear.js',
  //           dataType: 'json',
  //           success: function() {
  //            window.refreshCart();
  //           },
  //           error: function(XMLHttpRequest, textStatus) {
  //             console.error('Error clearing cart:', textStatus);
  //           }
  //     });
  // }

  // function clearCart() {
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/clear.js',
  //       dataType: 'json',
  //       success: function() {
  //         // Optional: Update the cart display or show a message
  //         location.reload(); // Reload the page to reflect the cleared cart
  //       },
  //       error: function(XMLHttpRequest, textStatus) {
  //         // Handle errors if needed
  //         console.error('Error clearing cart:', textStatus);
  //       }
  //     });
  //   }

  $('.return_btn').click(function(e){
    console.log('testing');
      if (history.length > 1) {
         javascript&colon;history.back();
       
      }else{
        console.log('no history');
        e.preventDefault();
        window.location.replace('https://popoteetpapilles.com/#menus-de-la-semaine');
      } 
  });
  
$('.listForm').each(function(){
   $('.product-variant-value').each(function(){
      $(this).click(function(){
          var $variant = $(this).data('variant');
          var $price = $(this).data('price');
          $(this).parent().parent().parent().parent().parent().parent().find('.tocart').val($variant);
          $(this).parent().parent().parent().parent().parent().parent().parent().find('.large_price').html($price);
      });
   });
   
  $(this).on('submit', function(event) {
      event.preventDefault();
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $(this).serialize(),
          dataType: 'json',
          success: function() {
            window.refreshCart();
            $('body').addClass('sidebar-opened');
               $('.sidebar').addClass('sidebar--opened');
               $('.sidebar').css('display', 'grid');
            
          },
          error: function() {
            
          }
        });
  });
});


  $('button#backWindow').on('click', function(e){
      e.preventDefault();
      window.history.back();
  });

   
  
  // $('.facet-checkbox').each(function(){
  //   $(this).click(function(){
  //     $(this).toggleClass('facet-active');
  //     var $item = $(this).attr('class').split(' ')[1];
  //     var input = $(this).find('input');
  //     input.prop("checked", !input.prop("checked"));
  //    if($(this).hasClass('facet-active')){
  //       $('.product-item').each(function(){
  //         if($(this).hasClass($item)){
  //           $(this).addClass('show');
  //         }else{
  //           $(this).removeClass('show');
  //         }
  //       });
  //    }else{
  //       $('.product-item').each(function(){
  //         $(this).addClass('show');
  //       });
         
  //    }
  //   });
  // });

      if($.cookie("gardemangerFilter")){
          var Cookievalue = $.cookie("gardemangerFilter");
           console.log(Cookievalue);
          $('.facet-checkbox').each(function(){
            if($(this).attr('id') == Cookievalue){
               $(this).addClass('activeFilter');
            }
          });
        $('#main-collection-product-grid').children('.product-item').addClass('hidden');
        $('#main-collection-product-grid').children('div.' + Cookievalue + '').removeClass('hidden');
          
          
         
        }else{
            $('.facet-checkbox').each(function(){
    			$('#main-collection-product-grid').children('.product-item').removeClass('hidden');
    		});
        }

     	
	  	//var selectedClassArray = [];
		var selectedClass = " ";
      
	  	$('.facet-checkbox').click(function() {
              
			selectedClass = $(this).attr('id');
            $.cookie("gardemangerFilter", selectedClass);
			$('#main-collection-product-grid').children('div.' + selectedClass + '').removeClass('hidden');
			
			// let index = selectedClassArray.indexOf(selectedClass);
			// if (index >= 0) {
			// 	selectedClassArray.splice(index, 1);
			// } else {
			// 	selectedClassArray.push(selectedClass);
			// }
			$('.facet-checkbox').removeClass('activeFilter');
			$(this).toggleClass('activeFilter');
			//console.log(selectedClassArray);
              $('#main-collection-product-grid').children('.product-item').addClass('hidden');
 				//$.each( selectedClassArray, function( index, value ){
					$('#main-collection-product-grid').children('.product-item.' + selectedClass + '').removeClass('hidden');
 				//});

           // if(selectedClassArray.length === 0){
           //    $('#main-collection-product-grid').children('.product-item').removeClass('hidden');
           //  }

		return false;
		
	});
  // if(selectedClassArray.length === 0){
  //   $('#main-collection-product-grid').children('.product-item').removeClass('hidden');
  // }

  $( "li#menu-item-fonctionnement" ).after( '<li id="logo_img"><a href="/"><img src="https://cdn.shopify.com/s/files/1/0698/1081/5232/files/Bolduc-Lamare_2.png?v=1712686340" /></a></li>' );

  $('svg.grid').click(function(){
    $(this).hide();
    $('svg.list').show();
    $('.product-list-view.wrapper').addClass('grid_view');
  });

  $('svg.list').click(function(){
    $(this).hide();
    $('svg.grid').show();
    $('.product-list-view.wrapper').removeClass('grid_view');
  });

  $('*').addClass('animation');
// $('h1').addClass('--fade-in');
// $('h2').addClass('--fade-in');
// $('h3').addClass('--fade-in');
// $('h4').addClass('--fade-in');
// $('span').addClass('--fade-in');
// $('p').addClass('--fade-in');
// $('.description').addClass('--fade-in');
// $('a').addClass('--fade-in');
// $('figure').addClass('--fade-up');

  		var $line_segment = $('.animation');
		var $window = $(window);
		
    
    function check_if_in_view() {
		  var window_height = $window.height();
		  var window_top_position = $window.scrollTop();
		  var window_bottom_position = (window_top_position + window_height);
			
			//animations box
			$.each($line_segment, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('active');
			} 
		  });
		
			
		}

		$window.on('scroll resize', check_if_in_view);
		$window.trigger('scroll');

  
//   function updateCurvedText($curvedText, radius) {
//   $curvedText.css("min-width", "initial");
//   $curvedText.css("min-height", "initial");
//   var w = $curvedText.width(),
//    h = $curvedText.height();
//   $curvedText.css("min-width", w + "px");
//   $curvedText.css("min-height", h + "px");
//   var text = $curvedText.text();
//   var html = "";
// Array.from(text).forEach(function (letter) {
//     html += `<span>${letter}</span>`;
//   });
//   $curvedText.html(html);
// var $letters = $curvedText.find("span");
//   $letters.css({
//     position: "absolute",
//     height:`${radius}px`,
//     transformOrigin:"bottom center"
//   });
//   var radius = radius;
//   var circleLength = 2 * Math.PI * radius;
//   var angleRad = w/(2*radius);
//   var angle = 2.5 * angleRad * 360/Math.PI/text.length;
  
//   $letters.each(function(idx,el){
//     $(el).css({
//         transform:`translate(${w/2}px,0px) rotate(${idx * angle - text.length*angle/2}deg)`
//     })
//   });
// }
// var $curvedText = $(".badge_caption span.text-size--regular.increased-spacing");
// updateCurvedText($curvedText,80);
// function settingsChanged(){
//   $curvedText.text($(".text").val());
//   updateCurvedText($curvedText,$(".radius").val());
// }
$(".radius").on("input change",settingsChanged);
$(".text").on("input change",settingsChanged);
   // $(".badge_caption span.text-size--regular.increased-spacing").lettering();
});